import { render, staticRenderFns } from "./myorder.vue?vue&type=template&id=de379be8&scoped=true&"
import script from "./myorder.vue?vue&type=script&lang=js&"
export * from "./myorder.vue?vue&type=script&lang=js&"
import style0 from "./myorder.vue?vue&type=style&index=0&id=de379be8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de379be8",
  null
  
)

export default component.exports